import * as Yup from "yup";
import checkout from "./formCompanion";

const {
  formField: {
    propertyCode,
    inRoomDiningPropertyId,
    url,
    pmsPropertyId: pmsPropertyIdField,
    clientID,
    clientSecret,
    propertyID,
    pmsType: pmsTypeField,
  },
} = checkout;

const validationsCompanion = [
  Yup.object().shape({
    [propertyCode.name]: Yup.string().when(["showGuestCompanion", "company"], {
      is: (showGuestCompanion, company) =>
        showGuestCompanion === true && company !== "none" && company !== "hostaway",
      then: () => Yup.string().required(propertyCode.errorMsg),
    }),
    [url.name]: Yup.string().matches(
      /^https?:\/\/[-a-zA-Z0-9@:%._~#=]+(\/[-a-zA-Z0-9()@:%_.~#?&//=]*)?$/,
      url.invalidMsg
    ),
    [clientID.name]: Yup.string().when("company", {
      is: (company) => company === "hostaway",
      then: () => Yup.string().required(clientID.errorMsg),
    }),
    [clientSecret.name]: Yup.string().when("company", {
      is: (company) => company === "hostaway",
      then: () => Yup.string().required(clientSecret.errorMsg),
    }),
    [propertyID.name]: Yup.string().when("company", {
      is: (company) => company === "hostaway",
      then: () => Yup.string().required(propertyID.errorMsg),
    }),
  }),
  Yup.object().shape({
    [inRoomDiningPropertyId.name]: Yup.string().when(["inRoomDining", "diningCompany"], {
      is: (inRoomDining, diningCompany) => inRoomDining === true && diningCompany === "digi",
      then: () => Yup.string().required(inRoomDiningPropertyId.errorMsg),
    }),
  }),

  Yup.object().shape(
    {
      [pmsPropertyIdField.name]: Yup.string()
        .nullable()
        .when(pmsTypeField.name, {
          is: (pmsType) => !!pmsType?.value, // Check if PMS type has a valid value
          then: (schema) => schema.required(pmsPropertyIdField.errorMsg),
        }),
      [pmsTypeField.name]: Yup.object()
        .nullable()
        .when(pmsPropertyIdField.name, {
          is: (pmsPropertyId) => pmsPropertyId?.length > 0,
          then: (schema) =>
            schema.test({
              test: (pmsType) => !!pmsType?.value, // Validate the existence of value property
              message: pmsTypeField.errorMsg,
            }),
        }),
    },
    [pmsTypeField.name, pmsPropertyIdField.name] // Ensure proper dependency order
  ),
];

export default validationsCompanion;
